
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import TopIntro from './TopIntro.vue'
import Process from './Process.vue'
import { Observer } from 'mobx-vue'
import type { CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types.d.ts'

@Observer
@Component({
  components: {
    TopIntro,
    Process
  }
})
export default class LearnMap extends Vue {
  @Prop({ required: true }) readonly dataSource: CalligraphyLevel2JsonResp

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
